import Button from '@orn/shared-web/components/Button/Button';
import * as React from 'react';

import useAuthApi from '../../../hooks/useAuthApi';
import { OnboardingTitle } from '../../OnboardingLayout';

interface IForgotPasswordStepProps {
  email: string;
  onNext: (result: { requiresSmsOtp: boolean; phoneLast4?: string }) => void;
  onBack: () => void;
}

const ForgotPasswordStep = ({ email, onNext, onBack }: IForgotPasswordStepProps) => {
  const authApi = useAuthApi();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSendReset = React.useCallback(async () => {
    setIsSubmitting(true);
    const result = await authApi.forgotPassword({ email });
    setIsSubmitting(false);

    // Always transition regardless of result (API always returns success for privacy)
    onNext({
      requiresSmsOtp: result.ok ? result.data.requiresSmsOtp : false,
      phoneLast4: result.ok ? result.data.phoneLast4 : undefined,
    });
  }, [authApi, email, onNext]);

  return (
    <>
      <OnboardingTitle
        title="Forgot password?"
        onBack={onBack}
        subtitle={
          <span className="text-secondary text-sm">
            We&apos;ll send a password reset code to <span className="text-primary font-medium">{email}</span>.
          </span>
        }
      />

      <div className="flex w-full flex-col gap-4">
        <Button size="xl" color="quaternary" className="w-full" onClick={handleSendReset} isLoading={isSubmitting}>
          Send reset code
        </Button>
      </div>
    </>
  );
};

ForgotPasswordStep.displayName = 'ForgotPasswordStep';

export default ForgotPasswordStep;
